import React from 'react';
import styles from '../FundingHistory.module.scss';
import { infoIconGrayFill } from '../../../../../../../assets/hostedassets';

interface EmptyDataRowProps {
    message: string;
}

function EmptyDataRow({ message }: EmptyDataRowProps) {
    return (
        <div className={styles.tableRow}>
            <div
                className={styles.rowItem}
                style={{
                    gridColumn: '1 / -1',
                    textAlign: 'left',
                    padding: '1rem',
                    color: '#666',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <img className={styles.InfoIcon} src={infoIconGrayFill} height={'14px'} alt="info" />
                &nbsp; {message}
            </div>
        </div>
    );
}

export default EmptyDataRow;
